import * as lockersCold from 'app/mocks/data/machines/all/lockersCold'

export const lockerColdDiagnostic1 = {
    machine: {
        id: lockersCold.lockerCold1.id,
        type: lockersCold.lockerCold1.category,
    },
    internet: {
        is_online: true,
        last_loss_connection: '2022-12-27 08:26:49.219717',
        last_heartbeat_connection: '2022-12-27 08:26:49.219717',
    },
}

export const lockerColdDiagnostic2 = {
    machine: {
        id: lockersCold.lockerCold2.id,
        type: lockersCold.lockerCold2.category,
    },
    internet: {
        is_online: true,
        last_loss_connection: '2022-12-27 08:26:49.219717',
        last_heartbeat_connection: '2022-12-27 08:26:49.219717',
    },
}
